import { render, staticRenderFns } from "./v-phone-field.vue?vue&type=template&id=9aaa480c&scoped=true&"
import script from "./v-phone-field.vue?vue&type=script&lang=js&"
export * from "./v-phone-field.vue?vue&type=script&lang=js&"
import style0 from "./v-phone-field.vue?vue&type=style&index=0&id=9aaa480c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aaa480c",
  null
  
)

export default component.exports